import { dayjs } from "@thalamos/common";
import type { ExternalPatientLinkEnhanced } from "@thalamos/aspire-common";

const currentDate = dayjs();
const nearThreshold = currentDate.subtract(7, "days");
const farThreshold = currentDate.subtract(14, "days");

export const getBadgeColor = (
  dateLastProcessed: ExternalPatientLinkEnhanced["dateLastProcessed"],
) => {
  return dateLastProcessed === undefined
    ? "error"
    : dayjs(dateLastProcessed).isAfter(nearThreshold)
      ? undefined
      : dayjs(dateLastProcessed).isAfter(farThreshold)
        ? "warning"
        : "error";
};
